import React from "react";
import { Card, Button } from "react-bootstrap";

export default function TrainingCard(props) {
  const {
    szTrainingClassName,
    Address1,
    Address2,
    szClassTime,
    classdate,
    FacilityDesc1,
    FacilityDesc2,
  } = props.class;

  const mapsSelector = () => {
    const addressComponent = encodeURIComponent(`${Address1} ${Address2}`);
    const browserMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${addressComponent}`;
    const mobileMapsUrl = `maps://maps.google.com/maps?daddr=${addressComponent}`;
    if (
      navigator.platform.indexOf("iPhone") !== -1 ||
      navigator.platform.indexOf("iPad") !== -1 ||
      navigator.platform.indexOf("iPod") !== -1
    ) {
      window.open(mobileMapsUrl);
    } else {
      window.open(browserMapsUrl);
    }
  };
  return (
    <Card>
      <Card.Header>
        Training Class {props.index + 1} -{" "}
        <strong>{classdate ? classdate : <>Date unavailable</>}</strong>
      </Card.Header>
      <Card.Body>
        <Card.Text>
          Your Training Class:{" "}
          {szTrainingClassName ? (
            szTrainingClassName
          ) : (
            <>Class ID unavailable</>
          )}
          <br />
          Located at:{" "}
          {FacilityDesc1 ? FacilityDesc1 : <>Location Name unavailable</>}
          {FacilityDesc2 ? `, ${FacilityDesc2}` : ""}
          <br />
          Address:{" "}
          {Address1 && Address2 ? (
            `${Address1}, ${Address2}`
          ) : (
            <>Address unavailable</>
          )}
          <br />
          Date & Time: {classdate ? classdate : <>Date unavailable</>} at{" "}
          {szClassTime ? szClassTime : <>Time unavailable</>}
        </Card.Text>
      </Card.Body>
      <Card.Footer className="text-center">
        <Button
          variant="primary"
          onClick={mapsSelector}
          target="_blank"
          size="sm"
        >
          Directions
        </Button>
      </Card.Footer>
    </Card>
  );
}
